import gsap from 'gsap';

function onBeforeEnter(el) {
    el.style.opacity = 0
    el.style.height = 0
  }
function onEnter(el, done) {
    gsap.to(el, {
      opacity: 1,
      height: '1.6em',
      delay: el.dataset.index * 0.15,
      onComplete: done
    })
  }
function onLeave(el, done){
    gsap.to(el, {
      opacity: 0,
      height: 0,
      delay: el.dataset.index * 0.15,
      onComplete: done
    })
  }

  export {
    onBeforeEnter, onEnter,onLeave
  }